/**
 * > When using the esBuild API, all `process.env.NODE_ENV` expressions
 * > are automatically defined to `"production"` if all minification
 * > options are enabled and `"development"` otherwise. This only happens
 * > if `process`, `process.env`, and `process.env.NODE_ENV` are not already
 * > defined. This substitution is necessary to avoid code crashing instantly
 * > (since `process` is a Node API, not a web API).
 * > — https://esbuild.github.io/api/#platform
 */

const NODE_ENV = process.env.NODE_ENV
const IS_MOBILE = window.matchMedia('(any-pointer:coarse)').matches

// Main environment variables
const ENV = Object.freeze({
    // Node environment
    NAME: NODE_ENV,
    IS_PROD: NODE_ENV === 'production',
    IS_DEV: NODE_ENV === 'development',

    // Device
    IS_MOBILE,
    IS_DESKTOP: !IS_MOBILE,
    IS_TOUCH: 'ontouchstart' in document.documentElement,
    IS_MAC: navigator.userAgent.indexOf('Mac OS X') !== -1,

    // Reduced motion
    REDUCED_MOTION: window.matchMedia('(prefers-reduced-motion: reduce)').matches
})

// Main CSS classes used within the project
const CSS_CLASS = Object.freeze({
    LOADING: 'is-loading',
    LOADED: 'is-loaded',
    READY: 'is-ready',
    TOUCH: 'is-touch',
    FONTS_LOADED: 'has-fonts-loaded',
    LAZY_CONTAINER: 'a-asset',
    LAZY_LOADED: '-lazy-loaded',
    LAZY_LOADING: '-lazy-loading',
    LAZY_ERROR: '-lazy-error',
    REDUCED_MOTION: 'reduced-motion',
})

// Custom js events
const CUSTOM_EVENT = Object.freeze({
    RESIZE_END: 'loco.resizeEnd',
})

// Fonts parameters
const FONT = Object.freeze({
    EAGER: [
        { family: 'PP Neue Montreal', style: 'normal', weight: '500' },
        { family: 'PP Neue Montreal', style: 'normal', weight: '600' },
        { family: 'PP Monument Extended', style: 'normal', weight: '900' },
    ],
})

const API_ENDPOINTS = Object.freeze({
    FORM_CONTACT: '/api/contact',
    FORM_NEWSLETTER: '/api/newsletter',
    MODALS: {
        SHOW: '/api/modal/show',
        ATHLETE: '/api/modal/athlete',
        TEAM: '/api/modal/team-member',
    }
})

const MODAL_CONTENT_KEYS = Object.freeze(Object.keys(API_ENDPOINTS.MODALS).reduce((k, v) => (k[v] = v, k), {}))

// Global variables
const VARS = Object.freeze({
    window: {
        width: window.innerWidth,
        height: window.innerHeight,
    },
})

// Vue
const VUE_SETTINGS = Object.freeze({
    delimiters: ['v{', '}'],
})

export {
    ENV,
    CSS_CLASS,
    CUSTOM_EVENT,
    FONT,
    API_ENDPOINTS,
    MODAL_CONTENT_KEYS,
    VARS,
    VUE_SETTINGS,
}
